import { render, staticRenderFns } from "./select-delivery-orders.vue?vue&type=template&id=1d881e64&"
import script from "./select-delivery-orders.vue?vue&type=script&lang=js&"
export * from "./select-delivery-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports